<template>
  <div>
    <headerTop ref="getcount"></headerTop>
    <slider></slider>
<!--    <headerSearch></headerSearch>-->
    <div class="box pt80">
      <!-- 头部选择 -->
      <div class="flex m10 flexShop">
        <div class="mr20">
<!--          <a href="/">-->
<!--            <img-->
<!--              class="imgs"-->
<!--              src="@/assets/images/home/logo1.png"-->
<!--              alt=""-->
<!--              width="148px"-->
<!--            />-->
<!--          </a>-->
        </div>
        <div @click="shopcard" :class="tabs=='0'?'shopping mr20 fw600':'mr20'">
          <span :class="tabs=='0'?'fz24':'fz24 color50'"> {{ $t('shopping.cart') }}&nbsp;(</span>
          <span :class="tabs=='0'?'fz24 red':'fz24 red'">{{ validShoppingTotal }}</span>
          <span :class="tabs=='0'?'fz24':'fz24 color50'">)&nbsp;</span>
        </div>
        <div @click="xjshopcar" :class="tabs=='1'?'shopping mr20 fw600':'mr20'">
          <span :class="tabs=='1'?'fz24':'fz24 color50'">{{ $t('shopping.Inquiry') }}&nbsp;(</span>
          <span :class="tabs=='1'?'fz24 red':'fz24 red'">{{ allNum || 0 }}</span>
          <span :class="tabs=='1'?'fz24':'fz24 color50'">)&nbsp;</span>
        </div>
      </div>
      <div v-show="tabs == '0'">
        <div><Button type="primary" @click="openImp">{{ $t('shopping.Bulk') }}</Button></div>
        <div class="shopTableTop">
          <div style="width:180px;"> {{ $t('shopping.picture') }}</div>
          <div style="width:320px;"> {{ $t('shopping.info') }}</div>
          <div style="width:110px;"> {{ $t('shopping.place') }}</div>
          <div style="width:80px;"> {{ $t('shopping.stock') }}</div>
          <div style="width:100px;"> {{ $t('shopping.price') }}</div>
          <div style="width:110px;"> {{ $t('shopping.Purchase') }}</div>
          <div style="width:100px"> {{ $t('shopping.Subtotal') }}</div>
          <div style="flex:1">{{ $t('shopping.operate') }}</div>
        </div>
        <div v-if="tableData.length === 0">
          <Spin size="large" fix v-if="spinShow"></Spin>
          <div class="noDate">
            <div>
              <!--            <span class="iconfont icon-a-zu420"></span>-->
              <div class="emptyCartImage">
                <img src="@/assets/images/shoppingCart/emptyCart.png"/>
              </div>
              <div class="flex">
                <div class="shoppingNull">
                  <div class="center">
                    <span class="iconfont icon-gantanhao-xianxingyuankuang"></span>
                  </div>
                  <span>{{ $t('shopping.Sorry') }}</span>
                </div>
                <div class="ml10">
                  <Button type="primary" @click="goHome">{{ $t('home.return') }}</Button>
                </div>
              </div>
              <!--            <div class="goHome">-->
              <!--              <div @click="goHome">返回首页逛逛</div>-->
              <!--            </div>-->
            </div>
          </div>
        </div>
        <div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <vxe-table
            v-if="tableData.length>0"
            resizable
            ref="xTable"
            border="inner"
            align="center"
            :show-header="false"
            :showIcon="true"
            :tree-config="{ expandAll: true }"
            :checkbox-config="{
              trigger: 'click',
              checkMethod,
              checkAll: true
            }"
            :data="tableData"
            @checkbox-change="selectChangeEvent"
            @checkbox-all="selectChangeEventAll"
            :span-method="mergeRowMethod"
          >
            <vxe-table-column type="checkbox" title="全选" width="40"></vxe-table-column>
            <vxe-table-column field="shopName" >
              <template v-slot="{ row }">
                <div class="img" v-if="row.carBrandName" style="width:180px">
                  <img
                    v-if="row.pictureUrl"
                    :src="row.pictureUrl"
                    style="width: 60%; height: 100%"
                  />
                  <img
                    v-else
                    src="@/assets/images/shoppingCart/2.png"
                    style="width:60%; height: 100%"
                  />
                </div>
                <div v-else style="width:450%;text-align:left;display:flex;align-items: center">
                  <span
                    :class="{
                      jiapei: row.storeLevelName != '' ? true : false
                    }"
                    >{{ row.storeLevelName }}</span
                  >
                  <span class="iconfont icon-shangcheng red"></span>
                  <span @click="gohomePage(row)" class="fw600 pointer"> {{ row.shopName }}</span>
                  <!-- <span @click="go('im')"></span> -->
                <xiaopei :oppositeTenantId="row.tenantId" >
                 <i class="iconfont icon-a-lujing162"></i>
                </xiaopei>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="partComplexName"
              align="left"
              width="280px"
            >
              <template v-slot="{ row }">
                <!-- {{row}} -->
                <div @click="goPartsdetails(row)">
                  <div v-if="row.partComplexName">
                    <div>
                    <span class="ycj" v-if="row.qualityType">{{row.qualityType}}</span>
                    <span style="cursor: pointer;">{{ row.partComplexName }}</span>
                    </div>
                   <div class="oe-p" @mouseleave="closeRelevance(row)">
                   <span class="oe-w2">OE号：</span> 
                    <span
                     class="oe-w1"
                    @mouseenter="getRelevance(row.partId, row)"
                  >
                   <span class="oe-w2">{{ row.oeCodeList[0]}}</span>                        
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="row.oeCodeList.length > 1"
                    ></i>
                  </span>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="row.oeCodeList.length > 1"
                  >
                    <div
                      class="relevanceBox"
                      :class="row.isShow ? 'show' : ''"
                    >
                      <p v-for="i in row.oeCodeList.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                   </div>
                 </div>

                  <div class="tow">
                   <span style="margin:0">服务：</span> 
                    <span
                      v-for="(item, index) in row.promises"
                      :value="index"
                      :key="index"
                    >
                      <span
                        :class="{
                          'iconfont icon-a-lujing153':index === 0 ? true : false,
                          'iconfont icon-a-ziyuan5': index === 1 ? true : false,
                          'iconfont icon-a-ziyuan4': index === 2 ? true : false,
                          'iconfont icon-a-ziyuan21': index === 3 ? true : false
                        }"
                      ></span>
                      <!-- <span>{{ item.name }}</span> -->
                    </span>
                  </div>

                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="provinceCity" width="110px">
              <template v-slot="{ row }">
                <!-- <div v-if="row.realTimePrice"> -->
                  <div style="margin-bottom: 20px">
                    {{ row.shipCity }}{{ row.shipStore }}
                  </div>
                  <!-- <div>
                <div class="time">
                  <span class="iconfont icon-shijian"></span>
                  <span>2天5小时</span>
                </div>
              </div> -->
                <!-- </div> -->
              </template>
            </vxe-table-column>
             <vxe-table-column field="stock" width="80">
              <template v-slot="{ row }">
                <div v-if="row.realTimePrice">
                  <!-- <div>{{ row.stock }}{{ row.unitId }}</div> -->
                  <div v-if="row.stock < 10&&row.stock !=0" style="line-height: 0.3">
                    {{ row.stock }}{{ row.unitId }}
                  </div>
<!--                  <div v-else-if="row.stock==0" class="red fw600">缺货</div>-->
                  <div v-else-if="row.stock==0"  style="line-height: 0.3">缺货</div>
                  <div v-else>10+</div>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="realTimePrice" width="100px">
              <template v-slot="{ row }">
                <div v-if="row.realTimePrice">
                  <div v-if="row.activityType === 1" style="margin-top:20px">
                    <span style="padding:3px;border:1px solid #81d3f8;color:#81d3f8;border-radius:5px">买赠</span>
                  </div>
                  <div v-if="row.activityType === 2">
                    <span style="padding:3px;border:1px solid #facd91;color:#facd91;border-radius:5px">单品促销</span>
                  </div>
                  <div class="fw600">
                    <span>￥{{ row.realTimePrice }}</span>
                  </div>
                  <div v-if="row.activityType === 1 || row.activityType === 2">
                    <!-- <div class="time">
                    <span class="iconfont icon-shijian"></span>
                    <span>2天5小时</span>
                  </div> -->
                    <span style="font-size: 12px">{{row.timeHorizon}}</span>
                  </div>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="partNum" width="110" >
              <template v-slot="{ row }">
                <div class="hh" v-if="row.price">
                  <div v-noresub="1000" class="btn" @click="del(row)">
                    <span>-</span>
                  </div>
                  <div class="ipt">
                    <input
                      type="number"
                      :class="{ color: row.partNum > row.stock }"
                      v-model="row.partNum"
                      @blur="chg(row)"
                    />
                  </div>
                  <div class="btn2" @click="add(row)">
                    <span>+</span>
                  </div>
                </div>
                <span style="display:inline-block;font-size:12px;line-height: 5px;padding-left:10px;color:red;display:none;" :class="row.isShownumber?'show':''">
                库存不足
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="partCurrentAmount" width="100">
              <template v-slot="{ row }">
                <div v-if="row.promises">
                  <!-- <span style="color: #e90d0d">￥</span> -->
                  <span class="red fw600">{{ '￥' + row.partCurrentAmount }}
                  </span>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column>
              <template v-slot="{ row }">
                <div class="right" v-if="row.promises">
                  <div @click="Delete(row)" class="pointer" style="color: #F62B4E;">{{ $t('Invoice.delete') }} </div>
                  <!-- <div @click="follow(row)" class="pointer" style="color: #377CF1;">移到关注</div> -->
                </div>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <Affix :offset-bottom="0">
          <div v-if="!spinShow" class="addss">
            <div class="left">
              <Checkbox class="l-left" @on-change="all" v-model="single"
                >{{ $t('shopping.select') }}</Checkbox
              >
              <span @click="deleAll" class="pointer">{{ $t('shopping.delete') }}</span>
              <!-- <span @click="removegz" class="pointer">移到关注</span> -->
            </div>
            <div class="right">
              <span>
                {{ $t('shopping.selected') }}
                <span style="color: red">{{ leng }}</span>
                 {{ $t('shopping.pieces') }}
              </span>
              <span class="l-right">{{ $t('shopping.Total') }}： </span>
              <span style="color: red; display: inline-block">￥</span>
              <span class="m-right">{{ totalPrice }}</span>
              <button v-noresub="1000" v-if="!c" :class="tableData.length===0?'r-right bgDisabled':'r-right'" :disabled="tableData.length === 0" @click="end">
                {{ $t('shopping.settlement') }}
              </button>
              <button v-noresub="1000" v-else :class="tableData.length===0?'r-right bgDisabled':'r-right'" :disabled="tableData.length === 0" @click="ends">
                {{ $t('shopping.settlement') }}
              </button>
              <!-- <span v-if="!c" class="r-right" @click="end"> 结算 </span>
            <span v-else class="r-right" @click="ends"> 结算 </span> -->
            </div>
          </div>

          <!-- <div v-else>
          <div v-if="!spinShow" class="addss">
            <div class="left">
              <Checkbox class="l-left" @on-change="all" v-model="single"
                >全选dsadasdasdasdas</Checkbox
              >
              <span @click="deleAll">删除</span>
            </div>
            <div class="right">
              <span>
                已选商品
                <span style="color: red">{{ leng }}</span>
                件
              </span>
              <span class="l-right"> 合计 (不含运费)： </span>
              <span style="color: red; display: inline-block">￥</span>
              <span class="m-right">{{ totalPrice }}</span>
              <span class="r-right" @click="ends"> 结算 </span>
            </div>
          </div>
        </div> -->
        </Affix>
        <div class="footer">
          <div>
            {{ $t('shopping.Expired') }}
            <span class="noshopping">{{ invalidShoppingTotal }}</span>
            {{ $t('shopping.pieces') }}
          </div>
        </div>
        <vxe-table
          resizable
          ref="xTables"
          border="inner"
          align="center"
          :show-header="false"
          :showIcon="true"
          :tree-config="{ expandAll: true }"
          :data="tableData2"
          :span-method="mergeRowMethod"
        >
          <vxe-table-column field="shopName">
            <template v-slot="{ row }">
              <div class="img" style="width:180px" v-if="row.carBrandName">
                <img
                  v-if="row.pictureUrl"
                  :src="row.pictureUrl"
                  style="width: 60%; height: 100%"
                />
                <img
                  v-else
                  src="@/assets/images/shoppingCart/2.png"
                  style="width: 60%; height: 100%"
                />
              </div>
              <div v-else style="width:450%;text-align:left;display:flex;align-items: center">
                <span
                  :class="{
                    jiapei: row.storeLevelName != '' ? true : false
                  }"
                  >{{ row.storeLevelName }}</span
                >
                <!-- <span class="iconfont icon-a-zu248"></span> -->
                <span class="iconfont icon-shangcheng red"></span>
                <!-- 这期不做 -->
                <span @click="gohomePage(row)" class="fw600 pointer"> {{ row.shopName }}</span>
                <!-- <span  class="fw600 pointer"> {{ row.shopName }}</span> -->
                <xiaopei :oppositeTenantId="row.tenantId" >
                 <i class="iconfont icon-a-lujing162"></i>
                </xiaopei>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="partComplexName" align="left" width="350px">
            <template v-slot="{ row }">
              <div @click="goPartsdetails(row)">
                <div v-if="row.partComplexName" class="w22">
                  <div>                 
                  <span class="ycj" v-if="row.qualityType">{{
                    row.qualityType
                  }}</span>
                  <span style="cursor: pointer;">{{ row.partComplexName }}</span>
                  </div>
                   <div class="oe-p" @mouseleave="closeRelevance(row)">
                   <p>OE号：</p> 
                    <p
                     class="oe-w1"
                    @mouseenter="getRelevance(row.partId, row)"
                  >
                   <span>{{ row.oeCodeList[0]}}</span>                        
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="row.oeCodeList.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="row.oeCodeList.length > 1"
                  >
                    <div
                      class="relevanceBox"
                      :class="row.isShow ? 'show' : ''"
                    >
                      <p v-for="i in row.oeCodeList.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                </div>
                </div>
                <div class="tow">
                  <span style="margin:0">服务：</span> 
                  <span
                    v-for="(item, index) in row.promises"
                    :value="index"
                    :key="index"
                  >
                    <span
                      :class="{
                        'iconfont icon-a-lujing153': index === 0 ? true : false,
                        'iconfont icon-a-ziyuan5': index === 1 ? true : false,
                        'iconfont icon-a-ziyuan4': index === 2 ? true : false,
                        'iconfont icon-a-ziyuan21': index === 3 ? true : false
                      }"
                    ></span>
                    <!-- <span>{{ item.name }}</span> -->
                  </span>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="provinceCity" width="180px">
            <template v-slot="{ row }">
              <!-- <div v-if="row.carBrandId"> -->
                <div style="margin-bottom: 20px">
                    {{ row.shipCity }}{{ row.shipStore }}
                </div>
              <!-- </div> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="realTimePrice" width="100px">
            <template v-slot="{ row }">
              <div v-if="row.realTimePrice">
                <div v-if="false">
                  <span style="color: #e90d0d">￥</span>
                  <span class="money">
                    <b>{{ row.realTimePrice }}</b>
                  </span>
                </div>
                <div v-if="row.inquiry&&row.saleStatus!=2">
                  <span class="red fw600">询价</span>
                </div>
                <!-- <div>
                <div class="time">
                  <span class="iconfont icon-shijian"></span>
                  <span>2天5小时</span>
                </div>
              </div> -->
              </div>
            </template>
          </vxe-table-column>
<!--          <vxe-table-column field="stock" width="70px">-->
<!--            <template v-slot="{ row }">-->
<!--              <div v-if="row.realTimePrice">-->
<!--                <div v-if="row.stock < 10">{{ row.stock }}{{ row.unitId }}</div>-->
<!--                <div v-else>10+</div>-->
<!--              </div>-->
<!--            </template>-->
<!--          </vxe-table-column>-->
          <vxe-table-column width="170px">
            <template v-slot="{ row }">
              <div v-if="row.promises&&row.saleStatus==2">商品已下架</div>
              <div v-if="row.promises&&row.inquiry&&row.saleStatus!=2">商品变为询价</div>
            </template>
          </vxe-table-column>
          <vxe-table-column>
            <template v-slot="{ row }">
              <div class="right" v-if="row.promises">
                <div @click="Delete(row)" class="pointer" style="color: #F62B4E;">删除</div>
                <div @click="same(row)" class="pointer">找同款</div>
                <!-- <div v-if="row.inquiry&&row.saleStatus!=2"  class="pointer" @click="follow(row)" style="color: #377CF1;">移到关注</div> -->
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div v-show="tabs == '1'">
        <enquirycart
          ref="cart"
          @carsx="carsx"
          @getcardnum="getcardnum"
          :failureNum="failureNum"
        ></enquirycart>
      </div>
      <Footer></Footer>
    </div>
    <importXLS ref="importXLS" @refush="refush"></importXLS>
    <Modal v-model="modalJump" footer-hide :mask-closable="false" title="提示">
      <div>{{ modalJumpTitle }}</div>
      <div class="reminder">
        <Button type="primary" style="margin-right:20px" @click="ok"
          >确定</Button
        >
        <Button type="default" @click="cancel">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Footer from '@/views/base/common/footer-p.vue';
import headerTop from '@/views/base/common/header-top.vue';
import slider from '@/views/base/common/slider.vue';
// import headerSearch from '@/views/base/common/header-search.vue';
// import { awaken } from '@/api/xiaopei/shout.js'
import xiaopei from '@/views/xiaopei/index.vue'
import enquirycart from '@/views/shoppingCart/enquirycart.vue'
import importXLS from '@/views/shoppingCart/components/importXLS.vue'
import { tableListPost } from '@/api/orderInformation/orderInformation.js'
import {
  findListShoppCars,
  deleteShoppingCart,
  change,
  // firstShopping,
  getremovergz,
  getflush,
  getenquirycartnum
} from '@/api/shoppingCart/shoppingCart.js'
// import { nextTick } from 'vue/types/umd';
export default {
  // mixins: [awaken],   enquirycart
  components: {
    Footer,
    headerTop,
    slider,
    // headerSearch,
    enquirycart,
    xiaopei,
    importXLS
  },
  data() {
    return {
      show:false,
      tabs: '0', // 切换
      carids: [], // 购物车的id
      modalJumpTitle: '',
      modalJump: false,
      spinShow: false,
      invalidShoppingTotal: 0,
      validShoppingTotal: 0,
      affixInit: false,
      tableDataID: [],
      vxeAllChecked: null,
      allState: null,
      leng: '0',
      totalPrice: '0.00',
      select: [], // 选中的数据
      single: true,
      tableData: [],
      tableData2: [],
      falg: true,
      c: true,
      allNum: '', // 总的数量
      failureNum: null // 失效数量
    }
  },
  methods: {
    //将多列合并成一行
    mergeRowMethod({row, $rowIndex, column, data}) { 
      let fieldser = ['shopName']
      let cellValue = row[column.property]
      // console.log(cellValue,'cellValue');
      if(cellValue && fieldser.includes(column.property)){
        // console.log(cellValue,'cellValue');
        // console.log(fieldser.includes(column.property),'fieldser.includes(column.property)');
        return {rowspan: 1, colspan: 8};
      }
    },
    // 刷新购物车
    carsx() {
      this.$refs.getcount.getCount()
    },
    shopcard() {
      this.tabs = '0'
    },
    xjshopcar() {
      this.tabs = '1'
      this.$refs.cart.enquirydata(2)
    },
    //批量导入购物车
    openImp(){
      this.$refs.importXLS.openModal()
    },
    async removegz() {
      this.select1 = this.$refs.xTable.getCheckboxRecords()
      // console.log(this.select1)
      if (this.select1.length > 0) {
        let a = []
        a = this.select1.filter(el => {
          return el.partCurrentAmount != null
        })
        let params = []
        a.forEach(el => {
          params.push(el.id)
        })
        const res = await getremovergz(params)
        console.log(res)
        if (res.status) {
          this.cartLists(2)
          this.$refs.getcount.getCount()
        }
      }
    },
    cancel() {
      this.modalJump = false
    },
    // 询价数量以及失效商品数量
    async getcardnum() {
      const res = await getenquirycartnum()
      console.log(res)
      if (res.status) {
        this.allNum = res.data.validNum
        this.failureNum = res.data.failureNum
      }
    },
    // 一开始就算出选中的商品数量和总价
    addDA() {
      this.select = []
      this.tableData.filter(el => {
        el.children.filter(elChild => {
          this.select.push(elChild)
        })
      })
      let c = this.select.filter(el => {
        return el.partCurrentAmount != null
      })
      // console.log(c);
      // c[0].stock =0
      let dd = c.filter((item)=>{
        // console.log(item);
        if(item.stock !== 0){
        return item
        }
        // return item.stock !== 0
    //   if(item.stock == 0){
      
    //  }else{
    //    return item
    //  }
      })
      // console.log(dd);
      this.leng = dd.length
      let e = 0
      c.forEach(el => {
        if(el.stock ==0){

        }else{
        e += parseFloat(el.partCurrentAmount)
        }
        // console.log(el);

      })
      this.totalPrice = e.toFixed(2) || 0
    },
    async getflushsx() {
      const res = await getflush()
      console.log(res)
    },
     ok() {
      // let res = await firstShopping()
      // if (res.status) {
        this.cartLists(2)
        this.getflushsx()
        this.modalJump = false
      // } else {
        // this.$Message.error('服务异常，请稍后再试')
        this.spinShow = false
      // }
    },

     firstShopping() {
      this.spinShow = true
      // let res = await firstShopping()
      // console.log('aoiuf  h')
      // if (res.status) {
        this.cartLists()
      // } else {
        // this.$Message.error('服务异常，请稍后再试')
        this.spinShow = false
      // }
    },
    selectAllChildren(item,idx){
      let xTable=`xTable${idx}`
      console.log(xTable,this.$refs,111)
      if(item.checked) {
        this.$refs[xTable].setAllCheckboxRow()
      }else{
        this.$refs[xTable].clearCheckboxReserve()
      }
    },
    //  change 事件
    selectChangeEvent({ records }) {
      this.c = false
      this.select = records
      let cd = records.filter(el => {
        return el.id != undefined
      })
      if (cd.length === this.tableDataID.length) {
        this.single = true
      } else {
        this.single = false
      }

      let a = []
      a = this.select.filter(el => {
        return el.partCurrentAmount != null
      })
      this.leng = a.length
      let e = 0
      a.forEach(el => {
        e += parseFloat(el.partCurrentAmount)
      })
      this.totalPrice = e.toFixed(2) || 0
    },
    // vxe-table  自带的全选事件
    selectChangeEventAll({ checked }) {
      this.vxeAllChecked = checked
      this.single = checked
    },
    // 文本框失去焦点时做的校验
    chg(row) {
      console.log(row);
      // if (this.falg) {
      //   this.falg = false
      if(row.activityType && row.partNum <= row.giveNum) {
        row.partNum = row.giveNum
        return this.$Message.error('购买数量不能小于起购数量')
      }
      if (row.partNum > row.stock) {
        // row.partNum = row.stock
        row.isShownumber = true
      //  this.$set(row.isShownumber,'isShownumber',true) 
        // this.$Message.error('购买数量不能大于库存数量')
        // this.lengs(row,1)
        // console.log(this.totalPrice);
      }
      else{
      this.lengs(row)
      row.isShownumber = false
      }
      if (row.partNum < row.orderQuantity) {
        row.partNum = row.orderQuantity
      }
      if (+row.partNum === 0) {
        row.partNum = 1
      } else {
        row.partNum = parseInt(Math.abs(row.partNum))
        // row.date13 = (+row.partNum * row.date14).toFixed(2)
      }
      // this.lengs(row)
      // } else {
      //   this.$Message.error('服务暂时不可用')
      // }
    },
    // +
    add(val) {
      // if (this.falg) {
      //   this.falg = false
      if (val.partNum < val.stock) {
        val.partNum = +val.partNum + 1
        this.lengs(val)
        val.isShownumber = false
      } else {
        this.$Message.error('购买的数量不能大于库存')
      }
      // val.partCurrentAmount = (+val.partNum * val.realTimePrice).toFixed(2)
      // this.lengs(val)
      // } else {
      //   this.$Message.error('服务暂时不可用')
      // }
    },
    // -
    del(val) {
      console.log(val.partNum);
      // if (this.falg) {
      //   this.falg = false
      console.log(+val.partNum,'val.partNum');
      console.log(val.stock,'val.stock');
      if(val.activityType && val.partNum <= val.giveNum) {
        return this.$Message.error('购买数量不能小于起购数量')
      }
      if (+val.partNum === val.orderQuantity) {
        return
      }else if(val.partNum > val.stock){
        console.log(val.partNum -1,'666');
        if(val.partNum-1 >val.stock){
        val.partNum = +val.partNum - 1
        this.$Message.error('购买的数量不能大于库存')
        }else{
          val.partNum = +val.partNum - 1
          this.lengs(val)
          val.isShownumber = false
        }
      } 
      else {
        val.partNum = +val.partNum - 1
        // val.partCurrentAmount = (+val.partNum * val.realTimePrice).toFixed(2)
        this.lengs(val)
        val.isShownumber = false
      }
      // } else {
      //   this.$Message.error('服务暂时不可用')
      // }
    },
    // 删除本条数据
    async Delete(row) {
      this.$Modal.confirm({
        title: '是否要删除',
        onOk: async () => {
          this.spinShow = true
          let data = {}
          let params = [row.id]
          let res = await deleteShoppingCart(params, data)
          if (res.status) {
            this.cartLists(2)
            this.$refs.getcount.getCount()
            this.$Message.info('已删除')
            // location.reload()
          } else {
            this.$Message.error('删除失败')
          }
        },
        onCancel: () => {
          this.$Message.warning('已取消')
        }
      })
    },
    // 移到关注
    async follow(item) {
      let carid = []
      carid.push(item.id)
      // this.carids=JSON.stringify(JSON.stringify(carid))
      // console.log(carid);
      const res = await getremovergz(carid)
      if (res.status) {
        console.log('成功')
        this.cartLists(2)
        this.$refs.getcount.getCount()
      }
    },
    // 全选
    all(val) {
      this.c = false
      this.allState = val
      this.$refs.xTable.setAllCheckboxRow(val)
      this.getSelectEvent1()
    },
    async ends() {
      console.log('11111');
      // 这是效果
      //  let ret="10030,某某商品价格发生变化,这是一个测试的,就会说看看效果的"
      //  if(ret.indexOf('10030')!==-1){
      //   this.modalJump = true
      //    let cx =ret.indexOf(',')
      //    let pp=ret.substring(cx+1)
      //    this.modalJumpTitle=pp
      //    console.log(pp);
      //  }
      let c = []
      // this.tableData[0].children[0].stock =0
      let flag = true
      this.tableData.filter(el => {
        console.log(el);
        el.children.filter(el => {
          if(el.stock > 0){
          console.log(el);
          if(el.partNum > el.stock){
            flag = false
          }else{
          c.push(el.id)
          }
          }
        })
      })
      if(flag){
      let data = c
      let params = {}
      console.log(data,'ends');
      let res = await tableListPost(params, data)
      console.log(res);
      sessionStorage.setItem('indent', JSON.stringify(res.data))
      // if (res.message === '10029' || res.message === '10030') {
      //   this.modalJump = true
      //   this.modalJumpTitle =
      //     res.message === '10029'
      //       ? '商品价格有已发生变化，请重新下单!'
      //       : '商品库存数量不足，请重新下单!'
      // }
      if (res.message.indexOf('10030') !== -1) {
        this.modalJump = true
        let cx = res.message.indexOf(',')
        this.modalJumpTitle = res.message.substring(cx + 1)
      } else {
        this.$router.push({
          path: '/orderInformation'
        })
      }
      }else{
        this.$Message.warning('库存不足');
      }
      // const { href } = this.$router.resolve({
      //   path: '/orderInformation',
      //   query: { ids: c}
      // });
      //  window.open(href, '_blank', console.log(href));
    },
    getSelectEvent1() {
      this.select = this.$refs.xTable.getCheckboxRecords()
      let a = []
      a = this.select.filter(el => {
        return el.partCurrentAmount != null
      })
      this.leng = a.length
      let e = 0
      a.forEach(el => {
        e += parseFloat(el.partCurrentAmount)
      })
      this.totalPrice = e.toFixed(2) || 0
    },
    // 返回首页
    goHome() {
      this.$router.push('supportself')
    },
    // 计算价格
    async lengs(row) {
      console.log(row);
      let params = {}
      let data = {}
      data.tenantId = row.tenantId
      data.shopId = row.shopId
      data.partId = row.partId
      data.partNum = row.partNum
      data.sharehold = row.sharehold
      data.id = row.id
      data.source = 1
      if(row.storeId){
        data.storeId = row.storeId
      }
      // if(i == 1){
      //   let a = []
      //   a = this.select.filter(el => {
      //     return el.partCurrentAmount != null
      //   })
      //   this.leng = a.length
      //   let e = 0
      //   a.forEach(el => {
      //     e += +el.partCurrentAmount
      //   })
      //   // this.totalPrice = e || 0
      //   this.hhh(e, 2)
      // }else{

      let res = await change(params, data)
      if (res.status) {
        console.log(res,'8888');
        // this.falg = true
        row.partCurrentAmount = res.data.amount
        row.realTimePrice = res.data.price
        row.stock = res.data.stock
        let a = []
        a = this.select.filter(el => {
          return el.partCurrentAmount != null
        })
        this.leng = a.length
        let e = 0
        a.forEach(el => {
          e += +el.partCurrentAmount
        })
        // this.totalPrice = e || 0
        this.hhh(e, 2)
      }else{
        this.$Message.destroy()
      }
      // }

    },
    hhh(f, digit) {
      console.log(f, digit);
      let m = Math.pow(10, digit)
      // this.totalPrice =  parseInt(f * m, 10) / m
      this.totalPrice = (parseInt(f * m, 10) / m).toFixed(2)

    },
    // 便利购物车数据
    bianli(val) {
      val.filter(el => {
        if (el.stock && el.stock > 0) {
          this.tableDataID.push(el.id)
        }
        if (el.children && el.children.length > 0) {
          this.bianli(el.children)
        }
      })
    },
    xiaoshu(tab) {
      tab.filter(el => {
        el.checked=true;
        if (el.partCurrentAmount) {
          // this.tableDataID.push(el.id)
          el.partCurrentAmount = el.partCurrentAmount.toFixed(2)
          el.realTimePrice = el.realTimePrice.toFixed(2)
        }
        if (el.children && el.children.length > 0) {
          this.xiaoshu(el.children)
        }
      })
    },
    // shopName(data){
    //   data.
    // },
    // iview 中 Affix 一开始不显示的bug 需要滚动页面
    initAffix() {
      window.scrollBy(0, 100)
    },
     refush(){
      // let res = await firstShopping()
      // if (res.status) {
        // this.ok()
      this.cartLists(2)
     this.$refs.getcount.getCount()
      // }
    // this.ok()
    // this.cartLists()
    // this.firstShopping()
    // this.$refs.getcount.getCount()
    // this.$refs.getcount.xainshi()
    // this.$refs.getcount.getenquirydata()
    //  this.cartLists(2)
    //  this.$refs.getcount.getCount()
    },
    // 获取购物车数据
    async cartLists(num) {
      this.spinShow = true
      let data = {}
      let res = await findListShoppCars(data)
      if (res.status) {
        //  res.data.validShoppings = this.xiaoshu(res.data.validShoppings)
        // console.log(res)
        this.getcardnum()
        this.tableData = res.data.validShoppings
        this.validShoppingTotal = res.data.validShoppingTotal
        this.tableData2 = res.data.invalidShoppings
        // this.tableData2 = res.data.validShoppings 
        this.invalidShoppingTotal = res.data.invalidShoppingTotal

        if (num === 2) {
         this.$nextTick(()=>{
          if(this.tableData.length>0){
          // 让他渲染的时候不要折叠起来
          this.$refs.xTable.reloadData(this.tableData) // 有效数据
          // this.$refs.xTables.reloadData(this.tableData2)
        }else if (this.tableData2.length>0){
       this.$refs.xTables.reloadData(this.tableData2) // 失效数据
        }else{
          this.$refs.xTable.reloadData(this.tableData)
          this.$refs.xTables.reloadData(this.tableData2)
        }
          })
        }                
        // if (num === 2) {
        //   // 让他渲染的时候不要折叠起来
          // this.$refs.xTable.reloadData(this.tableData)

        // }
        this.$refs.xTables.reloadData(this.tableData2) // 失效数据
        this.bianli(this.tableData)
        this.xiaoshu(this.tableData)
        this.xiaoshu(this.tableData2)
        this.addDA()
        this.spinShow = false
        // this.getSelectEvent1()
      } else {
        this.$Message.error(res.message)
        this.spinShow = false
      }
    },
    // 多选删除
    async deleAll() {
      let a = []
      a = this.select.filter(el => {
        return el.partCurrentAmount != null
      })
      let params = []
      a.forEach(el => {
        params.push(el.id)
      })
      if (params.length > 0) {
        this.$Modal.confirm({
          title: '是否要删除',
          onOk: async () => {
            this.spinShow = true
            let data = {}
            let res = await deleteShoppingCart(params, data)
            if (res.status) {
              this.cartLists(2)
              this.$refs.getcount.getCount()
              this.$Message.info('删除成功')
            } else {
              this.$Message.error('删除失败')
            }
          }
        })
      } else {
        this.$Message.error('请选中一条数据')
      }
    },
    // 控制按钮是否可以点击
    checkMethod(row) {
      return row.row.stock != 0
    },
    // 跳转到商品详情
    goPartsdetails(row) {
      console.log(row);
      if(row.storeId){
        console.log('1111');
      const { href } = this.$router.resolve({
        path: '/Partsdetails',
        query: { partId: row.partId, leagueId:row.tenantId,storeId:row.storeId }
      })
      window.open(href, '_self', console.log(href))
      }else{
        console.log('2222');
      const { href } = this.$router.resolve({
        path: '/Partsdetails',
        query: { partId: row.partId,  }
      })
      window.open(href, '_self', console.log(href))
      }
    },
    // 跳转
    gohomePage(row) {
      const { href } = this.$router.resolve({
        path: '/homePage',
        query: {
          shopId: row.shopId,
          tenantId: row.tenantId,
          shopName: row.shopName
        }
      })
      window.open(href, '_self', console.log(href))
    },
    // 结算
    async end() {
      console.log('2222');
      let a = []
      a = this.select.filter(el => {
        return el.partCurrentAmount != null
      })
      let c = []
      a.forEach(el => {
        console.log(el)
        if(el.stock>0){
        c.push(el.id)
        }
      })

      let b = a.filter(el => {
        return el.partNum > el.stock
      })
      if (this.leng > 0) {
        if (b.length > 0) {
          this.$Message.error('购买数量不能大于库存数量')
        } else {
          let data = c
          let params = {}
          let res = await tableListPost(params, data)
          sessionStorage.setItem('indent', JSON.stringify(res.data))
          // if (res.message === '10029' || res.message === '10030') {
          //   this.modalJump = true
          //   this.modalJumpTitle =
          //     res.message === '10029'
          //       ? '商品价格有已发生变化，请重新下单!'
          //       : '商品库存数量不足，请重新下单!'
          // }
          if (res.message.indexOf('10030') !== -1) {
            this.modalJump = true
            let cx = res.message.indexOf(',')
            this.modalJumpTitle = res.message.substring(cx + 1)
          } else {
            this.$router.push({
              path: '/orderInformation'
            })
          }

          // const { href } = this.$router.resolve({
          //   path: '/orderInformation',
          //   query: { ids: c}
          // });
          //  window.open(href, '_blank', console.log(href));
        }
      } else {
        this.$Message.error('请选择要结算的商品')
      }
    },
    // 找同款
    same(row) {
      this.$router.push({
        path: '/partsSearch',
        query: { searchContent: row.partCode }
      })
    },
    // 展开
     getRelevance(partId, row) {
      console.log(partId)
      console.log(row.isShow)
      // row.isShow = true
      this.$set(row, 'isShow', true)
      // console.log(row.isShow);
      // console.log(row);
    },
    // 关闭oe
    closeRelevance(row) {
      this.$set(row, 'isShow', false)
    },
    },
    created() {
    this.initAffix()
    },
    mounted() {
    // 刷新页面时，Affix不显示bug
    window.onbeforeunload = function(e) {
      e = e || window.event
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        window.scrollBy(0, 1)
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      window.scrollBy(0, 1)
    }

    // iview 中 Affix 一开始不显示的bug 需要滚动页面
    window.scrollBy(0, 1)
    this.firstShopping()
  },
  watch: {
    vxeAllChecked(val, oldVal) {
      this.single = val
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
